
export default function MapNavService(gettext) {

    'ngInject';

    const module = {
        "id": "map",
        "name": gettext("Map"),
        "sref": "map",
        "icon": "fas fa-map-marker-alt",
        "priority": 100
    };

    return {
        getModule: () => module
    };
}
